import { defineAsyncComponent } from 'vue'

export default defineAsyncComponent(() => import('./AgGridVueWrapper.vue'))
